export const environment = {
  production: true,
  homologation: false,
  debug: false,
  urlContext: '/central-servicos',
  apiBaseUrl: 'https://secweb.procergs.com.br/ipespa/api',
  loginCidadao: {
    issuer: 'https://logincidadao.rs.gov.br',
    tokenEndpoint: 'https://secweb.procergs.com.br/ipespa/api/govbr/tokens',
    redirectUri: 'https://servicos.ipesaude.rs.gov.br/central-servicos',
    clientId: '231_38nbtewx3nk0gwsk888sk0ggcs88wkcook44ok04c4sw48ks4o',
    scope: 'full_name cpf email phone_number offline_access tag:aviseme.rs.gov.br,2017:send aviseme'
  },
  integracaoSoeAuth: {
    issuer: 'https://www.soe.rs.gov.br/soeauth',
    tokenEndpoint: 'https://www.soe.rs.gov.br/soeauth/connect/token',
    clientId: 'ipespa.i5.trAyazI0nthaJxSeQlcP',
    clientSecret: 'VrtL0UmRzP3mCil1MIe3it3w0'
  },
  habilitacoes: {
    consultaCobertura: true,
  }
};
